import { render, staticRenderFns } from "./ActivityPopupFilter.vue?vue&type=template&id=0b370978&scoped=true&"
import script from "./ActivityPopupFilter.vue?vue&type=script&lang=js&"
export * from "./ActivityPopupFilter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPopupFilter.vue?vue&type=style&index=0&id=0b370978&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b370978",
  null
  
)

export default component.exports